import React from "react";
import "../.css/comingsoon.css";
const ComingSoonMessage = ({ error }) => (
  <h1 className="Gradient-Text">Coming Soon!</h1>
);
export default ComingSoonMessage;



// WEBPACK FOOTER //
// ./src/components/ComingSoon.jsx